import { ComponentProps, useState } from 'react'
import styles from './Tag.module.scss'
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx'
import { TKind } from '../../utils';

interface ITag extends ComponentProps<"div"> {
  tag: string
  onRemove?: (tag: string) => void
  kind: TKind
}

const Tag = (props: ITag) => {
  const {tag, onRemove, kind='red', className, ...args} = props

  const [visibility, setVisibility] = useState<'hidden' | 'visible'>('hidden')

  return (
    <div 
      className={clsx(styles.root, styles[kind], className)}
      {...args}
      onMouseEnter={() => {
        setVisibility('visible')
      }}
      onMouseLeave={() => {
        setVisibility('hidden')
      }}
    >
      <p>{tag}</p>
      {onRemove && <CloseIcon 
        className={clsx(styles.close, styles[kind])} 
        style={{visibility}}
        onClick={() => {onRemove(tag)}}
      />}
    </div>
  )
}

export default Tag